module.exports = __webpack_public_path__ + "img/updatelog-6f5e296d.svg";